// extracted by mini-css-extract-plugin
module.exports = {"submit":"Submit-module__submit___1eIhb","submit-visible":"Submit-module__submit-visible___56Inc"};